import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { message } from "antd";
import "../../node_modules/antd/dist/antd.css";
function Navbar() {
  const [isLogged, setIsLogged] = useState(false);
  const [userName, setUserName] = useState("");
  useEffect(() => {
    setIsLogged(sessionStorage.getItem("isLogged"));
    setUserName(sessionStorage.getItem("userName"));
  }, []);
  const logout = () => {
    sessionStorage.removeItem("isLogged");
    sessionStorage.removeItem("userName");
    message.loading("Please Wait", [1], () => {
      setIsLogged(false);
      setUserName("");
      message.success("Successfully Logged out");
    });
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <a className="navbar-brand" href="#">
          useMango DemoWebsite
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav ml-auto">
            <Link className="nav-item nav-link active" to="/" id="home">
              Home <span className="sr-only">(current)</span>
            </Link>
            <Link className="nav-item nav-link" to="/about" id="about">
              About Us
            </Link>
            <Link className="nav-item nav-link" to="/products" id="products">
              Products
            </Link>
            <Link className="nav-item nav-link" to="/contact">
              Contact
            </Link>
          </div>
          <div className="navbar-nav ml-auto">
            {isLogged ? (
              <>
                <Link className="nav-item nav-link active" style={{ color: "white" }}>
                  Hello, {userName}
                </Link>
                <Link className="nav-item nav-link active" onClick={logout}>
                  <i className="fa fa-user mr-1" aria-hidden="true" />
                  Logout
                </Link>
              </>
            ) : (
              <Link to="/login" className="nav-item nav-link active">
                <i className="fa fa-user mr-1" aria-hidden="true" />
                Login
              </Link>
            )}

            <Link className="nav-item nav-link active" to="/cart">
              <i className="fa fa-shopping-bag mr-1" aria-hidden="true" />
              Cart
            </Link>
            <Link className="nav-item nav-link active" to="/wishlist">
              <i className="fa fa-heart mr-1" aria-hidden="true" />
              Wishlist
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}
export default Navbar;
